'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/deprecation-decorator/node_modules/core-js/internals/is-pure.js
// module id = 6112
// module chunks = 25